import languageBundle from '@kirschbaum-development/laravel-translations-loader?namespace=translation&parameters={{$1}}!@kirschbaum-development/laravel-translations-loader';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    resources: languageBundle,
    lng: window.CURRENT_LOCALE,
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
